var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pole-main"},[_c('div',{key:_vm.mapGLIndex,ref:"divStyle",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"mapGL"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }